var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBankBuildingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30874_57703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.61535 17.2602V8.31641H16.8078V17.2446C16.8078 17.3071 16.8078 17.3696 16.8078 17.4243C16.8078 17.5102 16.8232 17.5805 16.716 17.5805C15.9428 17.5805 15.1773 17.5805 14.4042 17.5805H3.42679C3.18182 17.5805 2.94452 17.5805 2.69955 17.5805C2.59238 17.5805 2.61535 17.5258 2.61535 17.4321V17.2681V17.2602Z",
    stroke: "#4F4F4F",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3466 7.01949V7.98295C18.3466 8.16824 18.1782 8.31646 17.9791 8.31646H1.56666C1.35998 8.31646 1.19922 8.16824 1.19922 7.98295V7.01949C1.19922 6.90091 1.26811 6.79715 1.37529 6.73786L9.58152 2.05393C9.704 1.98723 9.8571 1.98723 9.97193 2.05393L18.1782 6.73786C18.2853 6.79715 18.3542 6.90832 18.3542 7.01949H18.3466Z",
    stroke: "#4F4F4F",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8392 17.5713H0.998047",
    stroke: "#4F4F4F",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66797 8.33203V17.5181",
    stroke: "#3876BB",
    strokeWidth: 1.10778
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.502 8.33203V17.5181",
    stroke: "#3876BB",
    strokeWidth: 1.10778
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30874_57703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankBuildingIcon);
export default __webpack_public_path__ + "static/media/BankBuildingIcon.8f1b44ebcbe38f48bc38cde7962f19ba.svg";
export { ForwardRef as ReactComponent };